import script from "./FaIcons.vue?vue&type=script&lang=js"
export * from "./FaIcons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__